const utils = require('analytics/utils');
const skuUtils = require('utils/Sku');
const deepExtend = require('utils/deepExtend');
const anaConsts = require('analytics/constants');

const LINK_INFO = {
    CLICK_SIZE: 'product:alt-image:swatch:size',
    CLICK_COLOR: 'product:alt-image:swatch:click',
    HOVER: 'product:alt-image:swatch:hover',
    VIEW_MORE: 'product:alt-image:view more',
    VIEW_LESS: 'product:alt-image:view less'
};

const SPEC_EVENT_NAME = {
    CLICK: 'swatch_click',
    HOVER: 'swatch_hover',
    VIDEO: 'video_click'
};

module.exports = (function () {
    const pageClickBindings = function (data) {
        let currentProduct = data.currentProduct;
        let skuType = currentProduct.variationType;
        let currentEvent = utils.getMostRecentEvent(anaConsts.LINK_TRACKING_EVENT);
        switch (skuType) {
            case skuUtils.skuVariationType.SIZE:
            case skuUtils.skuVariationType.SIZE_CONCENTRATION_FORMULATION:
            case skuUtils.skuVariationType.SIZE_CONCENTRATION:
                deepExtend(currentEvent, {
                    eventInfo: {
                        attributes: {
                            linkName: 'D=c55',
                            actionInfo: LINK_INFO.CLICK_SIZE,
                            eventStrings: [anaConsts.Event.EVENT_71]
                        }
                    }
                });
                break;
            case skuUtils.skuVariationType.COLOR: {
                deepExtend(currentEvent, {
                    eventInfo: {
                        attributes: {
                            linkName: 'D=c55',
                            actionInfo: LINK_INFO.CLICK_COLOR,
                            eventStrings: [anaConsts.Event.EVENT_71]
                        }
                    }
                });
                break;
            }
            default:
        }
    };

    const pageHoverColorSwatchBindings = function () {
        let currentEvent = utils.getMostRecentEvent(anaConsts.LINK_TRACKING_EVENT);
        deepExtend(currentEvent, {
            eventInfo: {
                attributes: {
                    linkName: 'D=c55',
                    actionInfo: LINK_INFO.HOVER,
                    eventStrings: [anaConsts.Event.EVENT_71]
                }
            }
        });
    };

    const pageToggleColorSwatchBindings = function (data) {
        let currentEvent = utils.getMostRecentEvent(anaConsts.LINK_TRACKING_EVENT);
        deepExtend(currentEvent, {
            eventInfo: {
                attributes: {
                    linkName: 'D=c55',
                    actionInfo: data.isExpand ? LINK_INFO.VIEW_MORE : LINK_INFO.VIEW_LESS,
                    eventStrings: [anaConsts.Event.EVENT_71]
                }
            }
        });
    };

    const modalVideoClickBindings = function (videoItem, specificEventName) {
        return {
            specificEventName,
            linkName: anaConsts.LinkData.VIDEO_POPUP,
            actionInfo: anaConsts.LinkData.VIDEO_POPUP,
            eventStrings: [anaConsts.Event.EVENT_71, anaConsts.Event.EVENT_102],
            videoName: [
                digitalData.page.attributes.sephoraPageInfo.pageName,
                videoItem.videoTitle,
                videoItem.filePath
            ].join('_'),
            eVar63: 'D=g',
            internalCampaign: 'product_' + digitalData.product[0].attributes.world + '_video'
        };
    };

    return {
        pageClickBindings,
        pageHoverColorSwatchBindings,
        pageToggleColorSwatchBindings,
        modalVideoClickBindings,
        LINK_INFO: LINK_INFO,
        SPEC_EVENT_NAME: SPEC_EVENT_NAME
    };
}());
